import React from 'react';
import QuotesDetailsBox from './QuotesDetailsBox';
import { quotesPropType } from '../../utils/propTypes';

const QuotesCarousel = ({ quotes }) => {

  return (
    <div>
      <span>In Desktop and Tablet will convert list into Carousel Soon.</span>
      <div
        className="sui-grid @xs:sui-grid-cols-1 @2xl:sui-grid-cols-2 @5xl:sui-grid-cols-3
        sui-gap-4 sui-mb-5 @sm:sui-mb-0"
      >
        {quotes.map((quote) => (
          <QuotesDetailsBox key={quote.id} quote={quote} />
        ))}
      </div>
    </div>
  );
};
QuotesCarousel.propTypes = {
  quotes: quotesPropType
};

QuotesCarousel.defaultProps = {
  quotes: [],
};

export default QuotesCarousel;